import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * CanonicalURL Component - Adds canonical URL tag to prevent duplicate content
 * Helps search engines and AI crawlers understand the preferred URL for each page
 */
const CanonicalURL = ({ url }) => {
  const location = useLocation();
  
  useEffect(() => {
    // Remove existing canonical link if present
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Determine canonical URL - always use https://wealthcore.app (no www) to prevent duplicate content
    const baseUrl = 'https://wealthcore.app';
    const canonicalUrl = url || `${baseUrl}${location.pathname}`;
    
    // Create and add canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);

    return () => {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.remove();
      }
    };
  }, [location.pathname, url]);

  return null; // This component doesn't render anything
};

export default CanonicalURL;

